(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('ProvinceDetailController', ProvinceDetailController);

    ProvinceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Province', 'Country'];

    function ProvinceDetailController($scope, $rootScope, $stateParams, entity, Province, Country) {
        var vm = this;

        vm.province = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:provinceUpdate', function(event, result) {
            vm.province = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
